let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hss4G")).then(() => parcelRequire('g8AHf'));